import { useHealthblocksSWR, useSubjectId } from '@healthblocks-io/core'

export function useInvoiceLink() {
  const subjectId = useSubjectId()
  return useHealthblocksSWR<{
    url?: string
    code?: 'auth_missing' | 'env_missing' | 'oazis_missing'
    message?: string
  }>(subjectId ? `/navigation/pom-invoice?subjectId=${subjectId}` : null).data
}

export function useMealLink() {
  const subjectId = useSubjectId()
  return useHealthblocksSWR<{
    url?: string
    code?: 'auth_missing' | 'env_missing' | 'oazis_missing' | 'synops_error' | 'no_access'
    message?: string
  }>(subjectId ? `/navigation/meal?subjectId=${subjectId}` : null).data
}
